import { Box, Heading } from '@primer/react';
import * as React from 'react';
export default {
  Box,
  Heading,
  React
};